import { useSymbolsStore } from "../store/Symbols.js";
import { useSymbolsRender } from "../utils/useRender.js";
export var Quote = props => {
  var {
    Quote: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'Quote');
  return null;
};
Quote.displayName = 'JVR.Quote';